<template>
  <div>
    <el-select
      ref="RcSelect"
      v-skeleton="load[loading]"
      class="rc-select"
      :popper-class="comPopperClass"
      :value="value"
      v-bind="$attrs"
      :clearable="clearable"
      v-on="$listeners"
      @visible-change="visibleChange"
    >
      <template v-for="slot in slots" :slot="componentSlot(slot)">
        <slot v-if="isDefaultSlot(componentSlot(slot))" :name="slot">
          <el-option
            v-for="item in comOptions"
            :key="valAndLabel(item)"
            :style="{ 'width': `${width}px` }"
            :label="valAndLabel(item, 'label')"
            :value="valAndLabel(item, 'value')"
            v-on="$listeners"
          >
            <div v-if="showAll" class="all-params" :style="{ 'justify-content': center }">
              <span>{{item[val]}}</span>
              <span>{{item[label]}}</span>
            </div>
          </el-option>
          <rc-button v-if="loadMore" :class="loadText(true)" type="text" @click="loadMoreFn">{{loadText()}}</rc-button>
        </slot>
        <!-- 自定义其他插槽 -->
        <slot v-else :name="slot"></slot>
      </template>
    </el-select>
  </div>
</template>

<script>
import { slotMixins } from "../mixins/slotMixins";
import { strFirstWith, getApi, isPlainObject } from "@/utils";
import RcButton from "../RcButton";
export default {
  name: "RcSelect",
  components: { RcButton },
  mixins: [slotMixins],
  props: {
    value: [String, Number, Boolean, Array],
    options: {
      type: Array,
      default: () => []
    },
    slots: {
      type: Array,
      default: () => ["default", "prefix", "empty"]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    center: {
      type: String,
      default: "space-between"
    },
    showAll: {
      type: Boolean,
      default: false
    },
    replaceFields: {
      type: Object,
      default: () => ({})
    },
    apiReplaceFields: {
      type: Object,
      default: () => ({
        page: "page",
        size: "size",
        total: "total"
      })
    },
    api: {
      type: Object,
      default: () => ({
        model: "",
        name: ""
      })
    },
    isCreated: {
      type: Boolean,
      default: false
    },
    isMounted: {
      type: Boolean,
      default: false
    },
    formatter: Function,
    visibleApi: {
      type: Boolean,
      default: true
    },
    loadMore: {
      type: Boolean,
      default: false
    },
    loading: {
      type: String,
      default: "loading"
    },
    recordName: {
      type: String,
      default: "records"
    },
    popperClass: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      apiOptions: [],
      load: {},
      cancelLoading: false,
      loadMoreState: true,
      defReplaceFields: {
        value: "value",
        label: "label",
        page: "page",
        size: "size"
      },
      visibleState: false
    };
  },
  computed: {
    val() {
      return this.comReplaceFields.value;
    },
    label() {
      return this.comReplaceFields.label;
    },
    page() {
      return this.comReplaceFields.page;
    },
    size() {
      return this.comReplaceFields.size;
    },
    isApi() {
      return this.isApiFn("api");
    },
    comOptions: {
      get() {
        return [...this.options, ...this.apiOptions];
      },
      set(val) {
        this.$emit("update:comOptions", val);
      }
    },
    comReplaceFields() {
      const { defReplaceFields, replaceFields } = this;
      return { ...defReplaceFields, ...replaceFields };
    },
    comPopperClass() {
      return this.loadMore ? "rc-select-load-more" : this.popperClass;
    },
    loadText() {
      const { loadMoreState } = this;
      const more = loadMoreState ? "loadMore" : "noMore";
      return type => (type ? more : this.$t(`public.${more}`));
    }
  },
  mounted() {
    this.initApi("mounted");
  },
  created() {
    this.initApi("created");
  },
  methods: {
    valAndLabel(item, type) {
      const { val, label } = this;
      const isLabel = item[label] || item[val] || item;
      const isVal = item[val] || item[label] || item;
      return type === "label" ? isLabel : isVal;
    },
    allParams(item) {
      return `${item[this.val]} ${item[this.label]}`;
    },
    initApi(name) {
      if (this.loadMore) { this.cancelLoading = true; };
      this[`is${strFirstWith(name)}`] && this.isApi && this.initSelect();
    },
    isApiFn(api) {
      const { model, name } = this[api];
      return model && name && model[name];
    },
    getSelect() {
      this.isApi && this.initSelect();
    },
    initSelect() {
      getApi({
        self: this,
        loading: this.loading,
        api: this.isApi,
        name: "select",
        cancelLoading: this.cancelLoading,
        params: this.api.params,
        call: (data, res) => {
          const resData = isPlainObject(data) ? data[this.recordName] : data;
          const current = this.formatter && this.formatter(resData, res) || resData;
          if (this.loadMore) {
            this.apiOptions.push(...current);
          } else {
            this.apiOptions = current;
          }
          const { apiReplaceFields } = this;
          this.loadMoreState = !(Number(data[apiReplaceFields.page]) * Number(data[apiReplaceFields.size]) >= Number(data[apiReplaceFields.total]));
        }
      });
    },
    loadMoreFn() {
      if (this.loadMore && this.loadMoreState) {
        this.setLoadMoreParams();
        this.getSelect();
      }
    },
    setLoadMoreParams(val) {
      const { api } = this;
      const page = val || Number(Number(api.params[this.page]) + 1);
      if (api && api.params) {
        Object.assign(this.api.params, { [this.page]: page });
      }
    },
    clearData() {
      const { api } = this;
      this.apiOptions = [];
      this.$emit("update:options", []);
      if (api && api.params) {
        Object.assign(this.api.params, { [this.page]: 1 });
      }
    },
    visibleChange(bool) {
      if (bool && this.visibleApi) {
        this.clearData();
        this.getSelect();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rc-select{
  width: 100%;
}
.all-params {
  display: flex;
  span:nth-child(1) {
    margin-right: 8px;
  }
}
.noMore,.loadMore {
  width: 100%;
  border: none;
  height: 36px;
}
.loadMore {
  &:hover {
    background: #fff;
  }
}
.noMore {
  color: $scim-text-color !important;
}
</style>

<style lang="scss">
  .rc-select-load-more {
    width: auto;
    .el-select-dropdown__list{
      padding: 0;
    }
  }
</style>
